import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Box, Button, FormField, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePublication, { usePublicationForm } from '@hooks/usePublication'

const EditPublicationFileTransferSettingsModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updatePublication } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { publication } = modalPayload

  const {
    callbacks: { updatePublication: updateFn },
    updating,
  } = usePublication(publication)

  const {
    entityState,
    entityState: {
      ftp_host,
      ftp_password,
      ftp_path,
      ftp_port,
      ftp_username,
      options: {
        file_transfer_protocol,
        sftp_login_details: {
          host: sftp_host,
          password: sftp_password,
          path: sftp_path,
          port: sftp_port,
          username: sftp_username,
        },
      },
    },
    handlers,
  } = usePublicationForm(publication)

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'File Transfer Settings Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="File Transfer" titleSecondLine="Settings" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <FormField label="File Transfer Protocol">
            <select name="options.file_transfer_protocol" value={file_transfer_protocol} {...handlers}>
              <option value="">Default</option>
              <option value="ftp">FTP</option>
              <option value="sftp">SFTP</option>
            </select>
          </FormField>

          {file_transfer_protocol !== 'sftp' && (
            <>
              <FormField label="Host" marginTop="large">
                <input name="ftp_host" type="text" value={ftp_host} {...handlers} />
              </FormField>

              <FormField label="Port" marginTop="large">
                <input name="ftp_port" placeholder="Default" type="text" value={ftp_port} {...handlers} />
              </FormField>

              <FormField label="Username" marginTop="large">
                <input name="ftp_username" type="text" value={ftp_username} {...handlers} />
              </FormField>

              <FormField label="Password" marginTop="large">
                <input
                  autoComplete="new-password"
                  name="ftp_password"
                  placeholder="Leave blank to keep current password"
                  type="password"
                  value={ftp_password}
                  {...handlers}
                />
              </FormField>

              <FormField label="Artwork Path" marginTop="large">
                <input name="ftp_path" type="text" value={ftp_path} {...handlers} />
              </FormField>
            </>
          )}

          {file_transfer_protocol === 'sftp' && (
            <>
              <FormField label="Host" marginTop="large">
                <input name="options.sftp_login_details.host" type="text" value={sftp_host} {...handlers} />
              </FormField>

              <FormField label="Port" marginTop="large">
                <input
                  name="options.sftp_login_details.port"
                  placeholder="Default"
                  type="text"
                  value={sftp_port}
                  {...handlers}
                />
              </FormField>

              <FormField label="Username" marginTop="large">
                <input name="options.sftp_login_details.username" type="text" value={sftp_username} {...handlers} />
              </FormField>

              <FormField label="Password" marginTop="large">
                <input
                  autoComplete="new-password"
                  name="options.sftp_login_details.password"
                  placeholder="Leave blank to keep current password"
                  type="password"
                  value={sftp_password || ''}
                  {...handlers}
                />
              </FormField>

              <FormField label="Artwork Path" marginTop="large">
                <input name="options.sftp_login_details.path" type="text" value={sftp_path} {...handlers} />
              </FormField>
            </>
          )}
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updatePublication(updatePublicationPayload)}
          size="large"
        >
          Save File Transfer Settings
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

EditPublicationFileTransferSettingsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

EditPublicationFileTransferSettingsModal.defaultProps = {
  modalKey: 'EditPublicationFileTransferSettingsModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <EditPublicationFileTransferSettingsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
